import React, { Component } from 'react'; 
import { Link } from 'react-router-dom';

class Mapa extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Mapa Interactivo</h2>
              </header>
              <span className="containerjuego">
          <div className="content">
            <div>
            <h2>
            <iframe src="https://spritted.com/en/game/wrestle-jump-sumo-fever?embed" width="1080px" height="720px" title='Sumo'></iframe>
            </h2>
            </div>
        
          </div>
            <div>
            <div className="containerjuego">
               <Link className="button" to="juego">
                Regresar
              </Link>
            </div>
            </div>
            </span>
          </div>
          </div>
          );
    } 
} 

export default Mapa;